import React, { useState, useEffect } from 'react';
import './Popup.css';

function Popup() {
	const [popups, setPopups] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 800);
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		const hiddenForever = localStorage.getItem('popup_hidden_forever');
		const hiddenDate = localStorage.getItem('popup_hidden_date');
		const today = new Date().toDateString();
		
		if (hiddenForever === 'true' || hiddenDate === today) {
			return;
		}

		fetchPopups();
	}, []);

	const fetchPopups = async () => {
		try {
			const response = await fetch('https://api.weartoday.kr/api/products/popups/');
			const data = await response.json();
			setPopups(data);
		} catch (error) {
			console.error('팝업 로딩 실패:', error);
		}
	};

	const handleClose = () => {
		const today = new Date().toDateString();
		localStorage.setItem('popup_hidden_date', today);
		setPopups([]);
	};

	const handleHideForever = () => {
		localStorage.setItem('popup_hidden_forever', 'true');
		setPopups([]);
	};

	const handleLinkClick = (link) => {
		const today = new Date().toDateString();
		localStorage.setItem('popup_hidden_date', today);
		setPopups([]);
		if (link) {
			window.location.href = link;
		}
	};

	const handlePrev = () => {
		setCurrentIndex(prev => Math.max(0, prev - 1));
	};

	const handleNext = () => {
		setCurrentIndex(prev => Math.min(popups.length - 1, prev + 1));
	};

	if (popups.length === 0) return null;

	// 모바일: 현재 인덱스 팝업만 / PC: 전체
	const displayPopups = isMobile ? [popups[currentIndex]] : popups;

	return (
		<div className="popup-overlay">
			<div className="popup-wrapper">
				{displayPopups.map((popup) => {
					const imageUrl = popup.image ? `https://api.weartoday.kr${popup.image}` : null;
					
					return (
						<div key={popup.id} className="popup-container">
							<div className="popup-image-wrapper">
								{imageUrl && (
									<img 
										src={imageUrl}
										alt={popup.title} 
										className="popup-image"
										onError={(e) => { e.target.style.display = 'none'; }}
									/>
								)}
								<div className="popup-text-overlay">
									<h2>{popup.title}</h2>
									<div dangerouslySetInnerHTML={{ __html: popup.content.replace(/\n/g, '<br/>') }} />
									{popup.link && (
										<button className="popup-link-btn" onClick={() => handleLinkClick(popup.link)}>
											자세히 보기 →
										</button>
									)}
								</div>
							</div>
							
							{/* 모바일 페이지네이션 */}
							{isMobile && popups.length > 1 && (
								<div className="popup-indicator">
									<button onClick={handlePrev} disabled={currentIndex === 0}>◀</button>
									<span>{currentIndex + 1} / {popups.length}</span>
									<button onClick={handleNext} disabled={currentIndex === popups.length - 1}>▶</button>
								</div>
							)}
							
							<div className="popup-buttons">
								<button onClick={handleHideForever}>다시 보지 않기</button>
								<button onClick={handleClose}>닫기</button>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default Popup;
